import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./challanReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable";
import {
  challanReportGroupInfo,
  challanReporttDataObject,
} from "../config/challanReport.js";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { useHistory } from "react-router-dom";

let excelData = [];
let excelData2 = [];

function ChallanReport({ sessionObject }) {
  const history = useHistory();
  const shubhamColumns = React.useMemo(
    () => [
      {
        Header: "Challan No",
        accessor: "booking_chalan_no",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Challan Date",
        accessor: "booking_chalan_date",
        width: "100px",
        minWidth: "10px",
        Cell: ({ value }) => {
          value = value.split("T");
          return value[0];
        },
        canFilter: true,
      },
      {
        Header: "Vehicle No",
        accessor: "vehicle_no",
        canFilter: true,
      },
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        canFilter: true,
      },
      {
        Header: "Bill No",
        accessor: "bill_no",
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Billing Party",
        accessor: "billing_party_name",
        canFilter: true,
      },
      // {
      //   Header: "Destination",
      //   accessor: "destination_name",
      //   canFilter: true,
      // },
      // {
      //   Header: "Distance",
      //   accessor: "distance",
      //   canFilter: true,
      // },
      {
        Header: "No Of Pkgs",
        accessor: "no_of_pkgs",
        canFilter: true,
      },
      {
        Header: "Total Weight",
        accessor: "total_weight",
        canFilter: true,
      },
      {
        Header: "To Pay",
        accessor: "to_pay",
        canFilter: true,
      },
      {
        Header: "Paid",
        accessor: "paid",
        canFilter: true,
      },
      {
        Header: "To Be Billed",
        accessor: "tbb",
        canFilter: true,
      },
      {
        Header: "CEWB No.",
        accessor: "cewb_no",
        canFilter: true,
      },
      {
        Header: "Inwarded",
        accessor: "inwarded",
        canFilter: true,
      },
      {
        Header: "Created By",
        accessor: "created_by_name",
        width: "140px",
        canFilter: true,
      },
      // {
      //   Header: "Deleted",
      //   accessor: "deleted",
      //   canFilter: true,
      // },
    ],
    []
  );
  const nrabColumns = React.useMemo(
    () => [
      {
        Header: "Challan No",
        accessor: "booking_chalan_no",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Challan Date",
        accessor: "booking_chalan_date",
        width: "100px",
        minWidth: "10px",
        Cell: ({ value }) => {
          value = value.split("T");
          return value[0];
        },
        canFilter: true,
      },
      {
        Header: "Vehicle No",
        accessor: "vehicle_no",
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      // {
      //   Header: "Destination",
      //   accessor: "destination_name",
      //   canFilter: true,
      // },
      // {
      //   Header: "Distance",
      //   accessor: "distance",
      //   canFilter: true,
      // },
      {
        Header: "No Of Pkgs",
        accessor: "no_of_pkgs",
        canFilter: true,
      },
      {
        Header: "Total Weight",
        accessor: "total_weight",
        canFilter: true,
      },
      {
        Header: "Lorry Hire",
        accessor: "lorry_hire",
        canFilter: true,
      },
      {
        Header: "Advance",
        accessor: "advance1",
        canFilter: true,
      },
      {
        Header: "Balance",
        accessor: "balance_1",
        canFilter: true,
      },
      {
        Header: "To Pay",
        accessor: "to_pay",
        canFilter: true,
      },
      {
        Header: "Paid",
        accessor: "paid",
        canFilter: true,
      },
      {
        Header: "To Be Billed",
        accessor: "tbb",
        canFilter: true,
      },
      {
        Header: "CEWB No.",
        accessor: "cewb_no",
        canFilter: true,
      },
      {
        Header: "Inwarded",
        accessor: "inwarded",
        canFilter: true,
      },
      {
        Header: "Created By",
        accessor: "created_by_name",
        width: "140px",
        canFilter: true,
      },
      // {
      //   Header: "Deleted",
      //   accessor: "deleted",
      //   canFilter: true,
      // },
    ],
    []
  );

  const xpressColumns = React.useMemo(
    () => [
      {
        Header: "Challan No",
        accessor: "booking_chalan_no",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Challan Date",
        accessor: "booking_chalan_date",
        width: "100px",
        minWidth: "10px",
        Cell: ({ value }) => {
          value = value.split("T");
          return value[0];
        },
        canFilter: true,
      },
      {
        Header: "Vehicle No",
        accessor: "vehicle_no",
        canFilter: true,
      },
      {
        Header: "Billing Party",
        accessor: "billing_party_name",
        canFilter: true,
      },
      {
        Header: "Owner name",
        accessor: "owner_name",
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Item Name",
        accessor: "item_name",
        canFilter: true,
      },
      {
        Header: "Weight",
        accessor: "weight",
        canFilter: true,
      },
      {
        Header: "Advance 1",
        accessor: "advance1",
        canFilter: true,
      },
      {
        Header: "Advance 2",
        accessor: "advance2",
        canFilter: true,
      },
      {
        Header: "Lorry Hire",
        accessor: "lorry_hire",
        canFilter: true,
      },
      {
        Header: "Rate",
        accessor: "rate",
        canFilter: true,
      },
      {
        Header: "Balance",
        accessor: "balance_1",
        canFilter: true,
      },
    ],
    []
  );

  const guruColumns = React.useMemo(
    () => [
      {
        Header: "Challan No",
        accessor: "booking_chalan_no",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Challan Date",
        accessor: "booking_chalan_date",
        width: "100px",
        minWidth: "10px",
        Cell: ({ value }) => {
          value = value.split("T");
          return value[0];
        },
        canFilter: true,
      },
      {
        Header: "Vehicle No",
        accessor: "vehicle_no",
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      // {
      //   Header: "Destination",
      //   accessor: "destination_name",
      //   canFilter: true,
      // },
      // {
      //   Header: "Distance",
      //   accessor: "distance",
      //   canFilter: true,
      // },
      {
        Header: "No Of Pkgs",
        accessor: "no_of_pkgs",
        canFilter: true,
      },
      {
        Header: "Total Weight",
        accessor: "total_weight",
        canFilter: true,
      },
      {
        Header: "To Pay",
        accessor: "to_pay",
        canFilter: true,
      },
      {
        Header: "PF",
        accessor: "pf",
        canFilter: true,
      },
      {
        Header: "Paid",
        accessor: "paid",
        canFilter: true,
      },
      {
        Header: "To Be Billed",
        accessor: "tbb",
        canFilter: true,
      },
      {
        Header: "CEWB No.",
        accessor: "cewb_no",
        canFilter: true,
      },
      {
        Header: "Inwarded",
        accessor: "inwarded",
        canFilter: true,
      },
      {
        Header: "Created By",
        accessor: "created_by_name",
        width: "140px",
        canFilter: true,
      },
      // {
      //   Header: "Deleted",
      //   accessor: "deleted",
      //   canFilter: true,
      // },
    ],
    []
  );

  const defaultColumns = React.useMemo(
    () => [
      {
        Header: "Challan No",
        accessor: "booking_chalan_no",
        width: "100px",
        minWidth: "10px",
        canFilter: true,
      },
      {
        Header: "Challan Date",
        accessor: "booking_chalan_date",
        width: "100px",
        minWidth: "10px",
        Cell: ({ value }) => {
          value = value.split("T");
          return value[0];
        },
        canFilter: true,
      },
      {
        Header: "Driver Name",
        accessor: "driver_name",
        canFilter: true,
      },
      {
        Header: "Driver No.",
        accessor: "phone_no",
        canFilter: true,
      },
      {
        Header: "Vehicle No",
        accessor: "vehicle_no",
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      // {
      //   Header: "Destination",
      //   accessor: "destination_name",
      //   canFilter: true,
      // },
      // {
      //   Header: "Distance",
      //   accessor: "distance",
      //   canFilter: true,
      // },
      {
        Header: "No Of Pkgs",
        accessor: "no_of_pkgs",
        canFilter: true,
      },
      {
        Header: "Total Weight",
        accessor: "total_weight",
        canFilter: true,
      },
      {
        Header: "To Pay",
        accessor: "to_pay",
        canFilter: true,
      },
      {
        Header: "Paid",
        accessor: "paid",
        canFilter: true,
      },
      {
        Header: "To Be Billed",
        accessor: "tbb",
        canFilter: true,
      },
      {
        Header: "CEWB No.",
        accessor: "cewb_no",
        canFilter: true,
      },
      {
        Header: "Inwarded",
        accessor: "inwarded",
        canFilter: true,
      },
      {
        Header: "Created By",
        accessor: "created_by_name",
        width: "140px",
        canFilter: true,
      },
      // {
      //   Header: "Deleted",
      //   accessor: "deleted",
      //   canFilter: true,
      // },
    ],
    []
  );

  const getColumnsBasedOnClient = () => {
    if (process.env.REACT_APP_CLIENT == "shubham") {
      return shubhamColumns;
    } else if (process.env.REACT_APP_CLIENT == "nrab") {
      return nrabColumns;
    } else if (process.env.REACT_APP_CLIENT == "guru") {
      return guruColumns;
    } else if (process.env.REACT_APP_CLIENT == "xpress") {
      return xpressColumns;
    } else {
      return defaultColumns;
    }
  };

  const columns = getColumnsBasedOnClient();

  // We'll start our table without any data
  const [data, setData] = React.useState([]);
  const [extraData, setextraData] = React.useState([]);
  const [isTruckSummary, setIsTruckSummary] = React.useState("0");
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const fetchIdRef = React.useRef(0);
  let download_ref = React.useRef(null);
  let download_ref1 = React.useRef(null);
  const sortIdRef = React.useRef(0);
  const [dateState, setDateState] = React.useState({
    date_from: new Date(),
    date_to: new Date(),
    pending_trip: "2",
    pending_bilty: "2",
    pending_bill: "2",
    all_branch: process.env.REACT_APP_CLIENT == "gdala_log" ? "N" : "Y",
  });
  const [finalInput, setFinalInput] = React.useState({});
  const [pageState, setPageState] = React.useState({
    total_amount: 0,
    total_weight: 0,
    total_pkgs: 0,
    total_bilties: 0,
  });

  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
      // This will get called when the table needs new data
      // You could fetch your data from literally anywhere,
      // even a server. But for this example, we'll just fake it.

      // Give this fetch an ID
      const fetchId = ++fetchIdRef.current;
      // Set the loading state
      setLoading(true);

      let newObject = {};
      if (fetchId === fetchIdRef.current) {
        // customFilters.created_from = String(
        //     sessionObject.sessionVariables.branch_id
        // );

        if (dateObject.pending_trip == "1") {
          newObject.pending_trip = String(1);
        }
        if (dateObject.pending_bilty == "1") {
          newObject.pending_bilty = String(1);
        }
        if (dateObject.pending_bill == "1") {
          newObject.pending_bill = String(1);
        }
        if (dateObject.all_branch == "N") {
          newObject.created_from = String(
            sessionObject.sessionVariables.branch_id
          );
        }

        // if (dateObject.all_branch == "Y") {
        //     newObject.created_from = null
        // }
        newObject = { ...newObject, ...customFilters };

        let inputData = {
          paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
          sort_fields: sortBy,
          filter_fields: newObject,
          date_dict: {
            date_from: dateObject.date_from,
            date_to: dateObject.date_to,
          },
        };

        setFinalInput(inputData);
        let response = await fetch(SERVER_URL + "/report/challan", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(inputData),
        });
        let resp = await response.json();
        let setObj = {};
        if (fetchId == fetchIdRef.current) {
          if (resp["challan_summary"] && "total_rows" in resp) {
            if (resp.total_rows !== 0) {
              setextraData(resp["challan_summary"]);
            } else {
              setextraData([]);
            }
          }
          if (resp["data"] && "total_rows" in resp) {
            if (resp.total_rows !== 0) {
              setData(resp["data"]);
            } else {
              setData([]);
            }
            setPageCount(Math.ceil(resp["total_rows"] / pageSize));
            setObj = {
              total_weight: resp["total_weight"],
              total_pkgs: resp["total_pkgs"],
              total_memo: resp["total_rows"],
            };
            setPageState({ ...pageState, ...setObj });
          }
          setLoading(false);
        }

        function extractUniqueCitiesByStation(responseData) {
          // Use Sets to keep track of unique cities for each station
          const uniqueFromCities = new Set();
          const uniqueToCities = new Set();
          responseData.forEach((item) => {
            // Add station_from_name to the Set
            if (item.station_from_name) {
              uniqueFromCities.add(item.station_from_name);
            }
            // Add station_to_name to the Set
            if (item.station_to_name) {
              uniqueToCities.add(item.station_to_name);
            }
          });
          // Convert Sets to Arrays and sort them
          const sortedFromCities = Array.from(uniqueFromCities).sort();
          const sortedToCities = Array.from(uniqueToCities).sort();
          return {
            fromCities: sortedFromCities,
            toCities: sortedToCities,
          };
        }

        const { fromCities, toCities } = extractUniqueCitiesByStation(
          resp.data
        );
        if (fromCities === undefined || fromCities.length === 0) {
          localStorage.setItem("fromCities", JSON.stringify([]));
        } else {
          localStorage.setItem("fromCities", JSON.stringify(fromCities));
        }

        if (toCities === undefined || toCities.length === 0) {
          localStorage.setItem("toCities", JSON.stringify([]));
        } else {
          localStorage.setItem("toCities", JSON.stringify(toCities));
        }
      }
      // We'll even set a delay to simulate a server here
      //   setTimeout(() => {
      //     // Only update the data if this is the latest fetch
      //     if (fetchId === fetchIdRef.current) {
      //       const startRow = pageSize * pageIndex;
      //       const endRow = startRow + pageSize;
      //     //   setData(serverData.slice(startRow, endRow));
      //       // Your server could send back total page count.
      //       // For now we'll just fake it, too
      //       setPageCount(Math.ceil(serverData.length / pageSize));

      //       setLoading(false);
      //     }
      //   }, 1000);
    },
    []
  );

  const handleViewClick = (cell) => {
    history.push("/challan", cell[0].value);
    //   history.push("/challan", 40001);
  };

  return (
    <div className="report-challan">
      <div className="form-header">Challan Report</div>

      <div className="report-challan-table-container">
        <div className="report-field-row">
          <div>
            From Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_from}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_from"]: date,
                })
              }
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              // disabled={checkDisabledCondition({ name: "input_date" })}
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularFieldForItem(
              //       "eway_bill_no",
              //       0,
              //       "eway_bill_no"
              //     );
              //   }
              // }}
            />
          </div>
          <div>
            To Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_to}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_to"]: date,
                })
              }
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              // disabled={checkDisabledCondition({ name: "input_date" })}
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularFieldForItem(
              //       "eway_bill_no",
              //       0,
              //       "eway_bill_no"
              //     );
              //   }
              // }}
            />
          </div>
          <div>
            <label>Pending Bhada Chitthi?</label>
            <select
              onChange={(e) => {
                const { name, value } = e.target;
                setDateState({
                  ...dateState,
                  [name]: value,
                });
              }}
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
              // disabled={checkDisabledCondition({ name: "is_crossing" })}
              value={dateState["pending_trip"]}
              name="pending_trip"
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     a.preventDefault();
              //     if (
              //       myForm.pageState.is_crossing == "N" ||
              //       myForm.pageState.is_crossing == "n"
              //     ) {
              //       myForm.makeFocusOnParticularField("bilty_no");
              //       return;
              //     } else {
              //       myForm.makeFocusOnParticularField("transporter_name");
              //       return;
              //     }
              //   }
              // }}
            >
              <option value="1" key="1">
                Yes
              </option>
              <option value="2" key="2">
                No
              </option>
            </select>
            {process.env.REACT_APP_CLIENT == "gdala_log" ? (
              sessionObject.sessionVariables.role_id == 1 ? (
                <>
                  <label>All aBranch?</label>
                  <select
                    onChange={(e) => {
                      const { name, value } = e.target;
                      setDateState({
                        ...dateState,
                        [name]: value,
                      });
                    }}
                    // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
                    // disabled={checkDisabledCondition({ name: "is_crossing" })}
                    value={dateState["all_branch"]}
                    name="all_branch"
                  >
                    <option value="N" key="N">
                      N
                    </option>
                    <option value="Y" key="Y">
                      Y
                    </option>
                  </select>
                </>
              ) : null
            ) : (
              <>
                <label>All Branch?</label>
                <select
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setDateState({
                      ...dateState,
                      [name]: value,
                    });
                  }}
                  // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
                  // disabled={checkDisabledCondition({ name: "is_crossing" })}
                  value={dateState["all_branch"]}
                  name="all_branch"
                >
                  <option value="N" key="N">
                    N
                  </option>
                  <option value="Y" key="Y">
                    Y
                  </option>
                </select>
              </>
            )}
            {process.env.REACT_APP_CLIENT == "shubham" && (
              <>
                <label>Pending Docket?</label>
                <select
                  onChange={(e) => {
                    const { name, value } = e.target;
                    if (value === "1") {
                      setDateState({
                        ...dateState,
                        [name]: value,
                        pending_bill: "2",
                      });
                    } else {
                      setDateState({
                        ...dateState,
                        [name]: value,
                      });
                    }
                  }}
                  value={dateState["pending_bilty"]}
                  name="pending_bilty"
                >
                  <option value="1" key="1">
                    Yes
                  </option>
                  <option value="2" key="2">
                    No
                  </option>
                </select>
                <label>Pending Bill?</label>
                <select
                  onChange={(e) => {
                    const { name, value } = e.target;
                    if (value === "1") {
                      setDateState({
                        ...dateState,
                        [name]: value,
                        pending_bilty: "2",
                      });
                    } else {
                      setDateState({
                        ...dateState,
                        [name]: value,
                      });
                    }
                  }}
                  value={dateState["pending_bill"]}
                  name="pending_bill"
                >
                  <option value="1" key="1">
                    Yes
                  </option>
                  <option value="2" key="2">
                    No
                  </option>
                </select>
              </>
            )}
          </div>
        </div>

        <div className="chform-row">
          {challanReportGroupInfo["group-1"].map(function (info) {
            return (
              <div className={info["className"]} key={info["name"]}>
                <label className={info["labelClassName"]}>
                  {info["label"]}:
                </label>
                <input
                  size="8"
                  disabled={true}
                  type={info["type"]}
                  value={pageState[info["name"]]}
                />
                {/* </label> */}
              </div>
            );
          })}
        </div>

        <ReportTable
          columns={columns}
          data={data}
          extraData={extraData}
          fetchData={fetchData}
          dateObject={dateState}
          loading={loading}
          pageCount={pageCount}
          canView={true}
          handleViewClick={handleViewClick}
          extraPrint={true}
          formName={"challanReport"}
        />

        <div className="form-footer">
          <label>Is Truck Summary?</label>
          <select
            onChange={(e) => {
              const { name, value } = e.target;
              setIsTruckSummary(value);
            }}
            // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
            // disabled={checkDisabledCondition({ name: "is_crossing" })}
            value={dateState["in_stock"]}
            name="in_stock"
          >
            <option value="0" key="1">
              No
            </option>
            <option value="1" key="2">
              Yes
            </option>
          </select>
          <button style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="btn btn-primary"
              table="challan_report_excel"
              filename="tablexls"
              sheet="tablexls"
              buttonText="Download as XLS"
              ref={(a) => (download_ref.current = a)}
            />
          </button>
          <button
            className="btn btn-primary"
            onClick={async () => {
              setLoading(true);

              let inputData = {
                sort_fields: finalInput.sort_fields,
                filter_fields: finalInput.filter_fields,
                date_dict: finalInput.date_dict,
              };

              let url = "";

              if (isTruckSummary == "0") {
                url = "/report/challan";
              } else {
                url = "/report/challan_with_grouping";
              }

              let response = await fetch(SERVER_URL + url, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(inputData),
              });

              let resp = await response.json();

              excelData = resp.data;
              excelData2 = resp.challan_summary;
              setLoading(false);
              download_ref.current.handleDownload();
            }}
          >
            Download as XLS
          </button>
          {ReportExcel.challan_report_excel(excelData, excelData2, dateState)}
          {/* New Button */}
          {/* <button style={{ display: "none" }}>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="btn btn-primary"
            table="multi_challan_report_excel"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Multi Challan XLS"
            ref={(a) => (download_ref1.current = a)}
          />
        </button>
        <button
          className="btn btn-primary"
          onClick={async () => {
            setLoading(true);

            let inputData = {
              sort_fields: finalInput.sort_fields,
              filter_fields: finalInput.filter_fields,
              date_dict: finalInput.date_dict,
            };

            let response = await fetch(SERVER_URL + "/report/challan", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(inputData),
            });

            let resp = await response.json();

            excelData2 = resp.challan_summary;
            setLoading(false);
            download_ref1.current.handleDownload();
          }}
        >
          Multi Challan XLS
        </button>
        {ReportExcel.multi_challan_report_excel(excelData2, dateState)} */}
        </div>
      </div>
    </div>
  );
}

export default ChallanReport;
